import DatabaseModel from './DatabaseModel.js';

var Departamento = Object.create(DatabaseModel);

Departamento.model = 'departamento';
Departamento.modelFront = 'departamentos';

export default Departamento;